import { gql } from "@apollo/client";
export const ADD_USER = gql`
  mutation addUser(
    $user_id: uuid
    $email: String!
    $name: String!
    $role: String!
    $picture_url: String
    $org_id: uuid
  ) {
    insert_user(
      objects: [
        {
          user_id: $user_id
          email: $email
          name: $name
          role: $role
          picture_url: $picture_url
          org_id: $org_id
        }
      ]
      on_conflict: { constraint: user_pkey, update_columns: [] }
    ) {
      affected_rows
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($id: uuid!, $user: user_set_input!) {
    update_user(where: { user_id: { _eq: $id } }, _set: $user) {
      affected_rows
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($id: uuid!) {
    delete_user(where: { user_id: { _eq: $id } }) {
      affected_rows
    }
  }
`;
